/**
 * 2026 state income-tax models (TAX-03/TAX-18). Each figure cites its source;
 * a year whose official schedule is not yet published is marked
 * `provisional` with the assumption stated.
 */

import type { FlatStateTaxModel, NoIndividualIncomeTaxModel, ProgressiveStateTaxModel } from './types.js';
import { CALIFORNIA_2025, COLORADO_2025, TEXAS_2025 } from './2025.js';

export const CALIFORNIA_2026: ProgressiveStateTaxModel = {
  ...CALIFORNIA_2025,
  taxYear: 2026,
  modelVersion: 'CA-2026-PROVISIONAL-FROM-2025',
  provisional: {
    basedOnYear: 2025,
    assumption: '2025 California schedules applied to 2026; FTB indexes and publishes the 2026 schedules late in the year — update when published.',
  },
};

export const COLORADO_2026: FlatStateTaxModel = {
  ...COLORADO_2025,
  taxYear: 2026,
  modelVersion: 'CO-2026-STATUTORY',
  rate: 0.044,
  provisional: {
    basedOnYear: 2026,
    assumption: 'Statutory 4.40% rate. A temporary TABOR rate reduction for 2026 depends on the FY 2025-26 surplus and is certified later — update if one is announced.',
  },
  sources: [
    {
      title: 'Colorado Legislative Council Staff, Economic & Revenue Forecast, September 2026',
      url: 'https://content.leg.colorado.gov/sites/default/files/2026-09/sept2026-forecast-with-cover-for-remediation-and-posting-accessible.pdf',
    },
    ...COLORADO_2025.sources,
  ],
};

export const TEXAS_2026: NoIndividualIncomeTaxModel = {
  ...TEXAS_2025,
  taxYear: 2026,
  modelVersion: 'TX-2026-NO-INDIVIDUAL-INCOME-TAX',
};
